import React from "react";

import ContactInfo from './components/ContactInfo';
import ContactMap from './components/ContactMap';

const Contact = ({ home }) => {


  return (
    <main className="Contact">
      <ContactInfo home={home} />
      <ContactMap />
    </main>
  );  
  
}

export default Contact;